// Fluent UI 统一主题配置
import {
  webLightTheme,
  teamsLightTheme,
  Theme,
} from "@fluentui/react-components";

// 统一字体配置
export const UNIFIED_FONT_FAMILY =
  "Microsoft YaHei UI, -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, sans-serif";

/**
 * 创建带有统一字体的主题
 * @param baseTheme 基础主题
 * @returns 带有统一字体的主题
 */
const createUnifiedTheme = (baseTheme: Theme): Theme => {
  return {
    ...baseTheme,
    fontFamilyBase: UNIFIED_FONT_FAMILY,
    fontFamilyMonospace: "'Consolas', 'Monaco', 'Courier New', monospace",
    fontFamilyNumeric: UNIFIED_FONT_FAMILY,
  };
};

// 导出统一主题
export const unifiedWebLightTheme = createUnifiedTheme(webLightTheme);
export const unifiedTeamsLightTheme = createUnifiedTheme(teamsLightTheme);

// 向后兼容
export const fluent9Theme = unifiedWebLightTheme;
export const fluent9TeamsTheme = unifiedTeamsLightTheme;

// 默认主题
export const defaultTheme = unifiedWebLightTheme;

/**
 * 获取统一的样式对象（用于内联样式）
 */
export const getUnifiedFontStyle = () => ({
  fontFamily: UNIFIED_FONT_FAMILY,
});

/**
 * 主题使用指南:
 *
 * 1. 推荐使用方式:
 *    <FluentProvider theme={defaultTheme}>
 *      // 您的组件
 *    </FluentProvider>
 *
 * 2. 如果需要使用 Teams 主题:
 *    <FluentProvider theme={unifiedTeamsLightTheme}>
 *      // 您的组件
 *    </FluentProvider>
 *
 * 3. 如果需要内联样式:
 *    <div style={getUnifiedFontStyle()}>
 *      // 您的内容
 *    </div>
 *
 * 4. 避免使用原始主题（webLightTheme, teamsLightTheme）
 *    因为它们没有统一的字体配置
 */
